const $ = window.jQuery;
import {
	OKEVENT,
	subscribeToOkEvent,
} from "shared/util/OkEventHelpers";

Ok.IncognitoSwitch = {
	init(param) {
		if (param == null) {
			param = {};
		}

		const { newTemplate, showOnboarding, activated } = param;
		this.Data = { newTemplate, showOnboarding, activated };
		this.Dom = {
			toggler: $(".incognito-toggler"),
			container: null,
			document: $(document),
		};

		// if they have no user_pane, they must be on the new template
		if (this.Data.newTemplate) {
			this.Dom.container = $("#navigation .nav-right");
			this.Data.source = "headerbar";
		} else {
			this.Dom.container = $("#user_pane");
			this.Data.source = "userpane";
		}

		const activatedPageState = PageState.get("incognitoActivated");

		if (
			activatedPageState != null &&
			activatedPageState !== this.Data.activated
		) {
			this.Data.activated = activatedPageState;
			this.render();
		}

		this.listen();
	},

	listen() {
		this.Dom.toggler.on("click tap", this.toggle.bind(this));
		subscribeToOkEvent(OKEVENT.IncognitoToggle, (ev) => {
			const { setting } = ev;
			this.updateSetting(setting);
		});
	},

	toggle() {
		// if onboarding is on, turn it off
		IncognitoOnboarding.graduate();

		let turnOn = !this.Data.activated;

		// update that shit optimistically
		OkC.post("/settings", {
			api: 1,
			data: {
				settings: {
					ENABLE_SELECT_MODE: turnOn,
				},
			},
			error: (response) => {
				// if there was an error, roll it back
				// and figure out what to do later
				turnOn = !turnOn;
				this.updateSetting(turnOn);
			},
		});

		// save it in page state
		PageState.set({ incognitoActivated: turnOn });

		this.updateSetting(turnOn);
	},

	updateSetting(turnOn) {
		this.Dom.container
			.removeClass("incognito-state-on incognito-state-off")
			.addClass(turnOn ? "incognito-state-on" : "incognito-state-off");

		this.Data.activated = turnOn;

		const turnOnText = turnOn ? "on" : "off";

		ClientStats.update({
			statnames: [
				`desktop - incognito - toggled - turned ${turnOnText}`,
				`desktop - incognito - toggled - source:${this.Data.source} - turned ${turnOnText}`,
			],
		});

		this.render();
	},

	render() {
		this.Dom.container
			.removeClass("incognito-state-on incognito-state-off")
			.addClass(this.Data.activated ? "incognito-state-on" : "incognito-state-off");
	},
};



// WEBPACK FOOTER //
// ./src/legacy/incognito/switch.js